export default "__VITE_ASSET__CVE0pJvh__"